<template>
  <div class="full-height">
    <q-card class="full-height">
      <q-card-section class="full-height">
        <div class="row">
          <div class="col-7 container-app">
            <div class="row title-row">
              <div class="title">Datos aplicación</div>
            </div>
            <div class="input-row">
              <q-input
                data-cy="name-app"
                v-model="v$.name.$model"
                outlined
                debounce="1000"
                :error="v$.name.$error"
                label="*Nombre aplicación"
                counter
                maxlength="50"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
                <template v-slot:hint>Restante</template>
              </q-input>
            </div>
            <div class="input-row">
              <q-select
                data-cy="type-app"
                outlined
                v-model="v$.typeApp.$model"
                :options="typeAppOpts"
                option-value="id"
                option-label="name"
                label="*Tipo de aplicación"
                :error="v$.typeApp.$error"
                @input="changeType"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-select>
            </div>
            <div class="input-row">
              <q-input
                data-cy="url-app"
                label="*Url"
                outlined
                debounce="1000"
                v-model="v$.url.$model"
                :error="v$.url.$error"
                class="col-12"
              >
                <template v-slot:error>URL no válida.</template>
              </q-input>
            </div>
            <div class="input-row" v-if="idApp">
              <q-field
                label="Identificador interno para autorización"
                data-cy="id-app"
                outlined
                stack-label
              >
                <template v-slot:control>
                  <div class="self-center full-width no-outline" tabindex="0">
                    {{ idApp }}
                  </div>
                </template>
              </q-field>
            </div>
            <div class="input-row">
              <q-toggle
                data-cy="toggle-conectada-app"
                color="primary"
                v-model="conectada"
                label="Aplicación conectada"
                left-label
              />
            </div>
          </div>
        </div>
        <div class="row bottom-page">
          <div class="col-10 info-box">
            <div style="margin-right: 6px">
              <q-img
                :src="require('@/assets/img/info-24px.svg')"
                width="24px"
                height="24px"
              />
            </div>
            <div class="txt-info">
              SI EL NOMBRE O DESCRIPCIÓN EXCEDE LOS LÍMITES RECOMENDADOS, LA
              INFORMACIÓN PUEDE NO VISUALIZARSE CORRECTAMENTE EN TODOS LOS
              DISPOSITIVOS.
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Validation from '@/components/shared/mixins/Validation.js';
import Formats from '@/components/shared/mixins/Formats.js';
import Resources from '@/components/shared/mixins/Resources.js';
import Loading from '@/components/shared/mixins/Loading.js';

import { QImg, QField, QToggle } from 'quasar';

const checkURL = (url) => Validation.methods.validateURL(url);

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QImg,
    QField,
    QToggle
  },
  mixins: [Message, Validation, Formats, Resources, Loading],
  validations: {
    name: { required },
    typeApp: { required },
    url: { required, checkURL }
  },
  props: {
    dataApp: Object,
    isLoading: Boolean,
    isNew: Boolean,
    eventName: String
  },
  data () {
    return {
      arrayApp: this.dataApp,
      idApp: null,
      name: null,
      typeApp: null,
      typeAppOpts: [],
      url: null,
      conectada: false
    };
  },
  computed: {},
  async mounted () {
    await this.getTypeAppOpts();
    this.$eventHub.$on(this.eventName, ({ callback, rejected }) =>
      this.checkToSave(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off(this.eventName);
  },
  methods: {
    async getTypeAppOpts () {
      this.showLoading();

      let request = {
        controller: '/Aplicacion/Types'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async (response) => {
          this.hideLoading();
          this.typeAppOpts = response.data;
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    // Check if name and url exist before save
    async checkToSave (callback, rejected) {
      this.v$.$touch();

      let returnValue = {
        data: null,
        status: false
      };

      if (this.v$.$error) return rejected(returnValue);

      returnValue = await this.saveValues();
      callback(returnValue);
    },
    // Save application values
    async saveValues () {
      let dataApp = {
        name: this.name,
        type: this.typeApp.id,
        url: this.url,
        conectada: this.conectada
      };

      let result = false;

      if (this.isNew) {
        result = await this.saveNewApp(dataApp);
      } else {
        result = await this.saveUpdates(dataApp);
      }

      return result;
    },
    async saveNewApp (dataApp) {
      let request = {
        controller: '/Aplicacion/',
        filter: {},
        body: dataApp
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.idApp = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });
      return responseData;
    },
    async saveUpdates (dataApp) {
      let request = {
        controller: '/Aplicacion/' + this.idApp,
        filter: {},
        body: dataApp
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
          this.$router.push({ name: 'aplicaciones' });
        });

      return responseData;
    },
    selectTypeOption (idOption) {
      return this.typeAppOpts.find(item => item.id === idOption);
    },
    async refillData () {
      this.idApp = this.arrayApp.id;
      this.name = this.arrayApp.name;
      this.url = this.arrayApp.url;
      this.typeApp = this.selectTypeOption(this.arrayApp.type);
      this.conectada = this.arrayApp.hasOwnProperty('conectada') ? this.arrayApp.conectada : false;
    },
    changeType (data) {
      this.$emit('changeType', data.id);
    }
  },
  watch: {
    dataApp: {
      handler: function () {
        this.arrayApp = this.dataApp;
        if (Object.entries(this.dataApp).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    },
    typeAppOpts: {
      handler: function () {
        this.typeApp = this.selectTypeOption(this.arrayApp.type);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-app {
  .input-row {
    padding: 16px 0px;
  }
  /* Desplaza el contador de caracteres a la izquierda */
  &:deep() {
    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }
  }
}

.bottom-page {
  .info-box {
    display: flex;
    align-items: center;
    .txt-info {
      font-size: 10px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.6;
      letter-spacing: 1.5px;
      color: rgba(0, 0, 0, 0.87);
    }
  }
}
</style>
